import SvgIcon from '@picsart/rc/old/SvgIcon';
import { ISvgIconProps } from '@picsart/rc/types/components/SvgIcon/types';
import { SxStyleProp } from 'theme-ui';

export enum IconTypes {
  White = 'White',
  Primary = 'Primary',
  Text2 = 'Text2',
  Tertiary = 'Tertiary',
  Error = 'Error',
  RatioFormat = 'RatioFormat',
  FloatingSettings = 'FloatingSettings',
  Crown = 'Crown'
}

const iconTypesStyles: { [key: string]: SxStyleProp } = {
  [IconTypes.White]: {
    path: {
      fill: '#ffffff'
    }
  },
  [IconTypes.Primary]: {
    path: {
      fill: 'primary'
    }
  },
  [IconTypes.Text2]: {
    path: {
      fill: 'grey4'
    }
  },
  [IconTypes.Tertiary]: {
    path: {
      fill: 'tertiary'
    }
  },
  [IconTypes.Error]: {
    path: {
      fill: 'error'
    }
  },
  [IconTypes.RatioFormat]: {
    path: {
      fill: 'grey9'
    }
  },
  [IconTypes.FloatingSettings]: {
    path: {
      fill: 'grey8'
    }
  },
  [IconTypes.Crown]: {
    path: {
      fill: 'gold'
    }
  }
};

const iconDefaultStyles: SxStyleProp = {
  display: 'block',
  width: '24px',
  height: '24px'
};

type IconType = {
  name: ISvgIconProps['name'];
  sx?: SxStyleProp;
  className?: string;
  type?: IconTypes;
};

export default ({ name, type, className, sx }: IconType): JSX.Element => {
  const gradientStyles: any = {};

  if (name === 'gold-circle-gen') {
    gradientStyles.svg = {
      background: 'linear-gradient(164.31deg, #F3A53A 0%, #BF5794 52.31%, #A0258F 100%)',
      borderRadius: '50%',
      '[fill="url(#gold-circle-gen-1)"]': {
        display: 'none'
      }
    };
  }

  const customStyle = sx || {};
  return (
    <SvgIcon
      sx={{ ...iconTypesStyles[type], ...iconDefaultStyles, ...customStyle, ...gradientStyles }}
      className={className}
      name={name}
    />
  );
};
